<template>
    <div>
        <div class="order-contents">
        <cart-nav
        :options="[ $t('cart_nav.choose_plan'), $t('cart_nav.confirm_details'), $t('cart_nav.complete') ]" :active="cartIndex"></cart-nav>

            <div class="order-center">
                <div class="banner-box">
                    <div class="banner-container">
                        <div class="banner">
                            <i class="icon-icon_have have-wrong" v-if='orderObj.status===paymentStatus.COMPLETED'></i>
                            <i class="icon-icon_wrong have-wrong"  v-if='orderObj.status===paymentStatus.FAILED|| orderObj.status===paymentStatus.EXPIRED|| orderObj.status===paymentStatus.CANCELLED'></i>
                        </div>
                        <div class="banner-text">
                            <h1 v-if='orderObj.status === paymentStatus.COMPLETED'>
                                {{ $t('order_complete.titleComplete') }}
                            </h1>
                            <h1 v-else-if='orderObj.status===paymentStatus.PENDING'>
                                {{ $t('order_complete.titlePending') }}
                            </h1>
                            <h1 v-else-if='orderObj.status===paymentStatus.PROCESSING'>
                                {{ $t('order_complete.titleProcessing') }}
                            </h1>
                            <h1 v-else-if='orderObj.status===paymentStatus.FAILED|| orderObj.status===paymentStatus.EXPIRED'>
                                {{ $t('order_complete.order_status_fail') }}
                            </h1>
                            <h1 v-else-if='orderObj.status===paymentStatus.CANCELLED'>
                                {{$t('order_complete.order_status_cancel')}}
                            </h1>
                        </div>
                    </div>
                </div>

                <div class="mobile-padding" v-if="show">
                   <p
                   class="send-email"
                   v-if='orderObj.status === paymentStatus.COMPLETED'
                   v-html="$t('order_complete.contact_us_success')"></p>
                   <p
                   class="send-email"
                   v-else-if='orderObj.status===paymentStatus.PENDING'
                   v-html="$t('order_complete.contact_us_pending')"></p>
                   <p
                   class="send-email"
                   v-else-if='orderObj.status===paymentStatus.PROCESSING'
                   v-html="$t('order_complete.contact_us_processing')"></p>
                   <p
                   class="send-email"
                   v-else-if='orderObj.status===paymentStatus.FAILED || orderObj.status===paymentStatus.EXPIRED'
                   v-html="$t('order_complete.contact_us_fail')"></p>
                   <p class="send-email" v-if='orderObj.status===paymentStatus.CANCELLED' v-html="$t('order_complete.contact_us_cancel')"></p>
                    <ul class="order-info">
                        <li class="order"><span>&bull; </span>{{$t('order_complete.payment_id')}}<span class="numbers">{{orderObj.id}}</span></li>
                        <li class="order"><span>&bull; </span>{{$t('order_complete.payment_date')}}
                            <span class="numbers">{{ $t('date_resolve.date_res',{en_date:timeFormat(timeStr)[0]})}}{{ $t('date_resolve.date_res',{de_date:timeFormat(timeStr)[1]})}} </span>
                        </li>
                        <li class="order"><span>&bull; </span>{{$t('order_complete.payment_status')}}<span class="numbers red" v-if="orderObj.status">{{$t(`payment_status.${orderObj.status}`)}}</span> </li>
                        <li v-if='orderObj.status===paymentStatus.FAILED' class="order fail-reason">&nbsp;&nbsp;({{$t('order_complete.fail_reason1')}})</li>
                        <li v-if='orderObj.status===paymentStatus.EXPIRED' class="order fail-reason">&nbsp;&nbsp;({{$t('order_complete.fail_reason2')}})</li>
                    </ul>
                    <div class="product">
                        <h3>{{$t('order_complete.cloud_plan')}}</h3>
                        <section class="product-sec">
                            <p class="reo-time">{{orderItems.name}}<span v-if="howUnit"> ({{ $tc( `cycle.${howUnit}`, howQue, {
                                count:howQue
                                })}})</span></p>
                            <p class="reo-price"> {{$t(`CURRENCY.${orderObj.currency}`)}} {{orderItems.price}}</p>
                        </section>
                    </div>
                    <div class="period">
                        <h3>{{$t('order_complete.plan_cycle')}}</h3>
                        <section class="period-sec">
                            <p class="reo-price">x {{orderItems.quantity}}</p>
                        </section>
                    </div>
                    <div class="total">
                        <section class="total-sec">
                            <h3>{{$t('order_complete.total')}}</h3>
                            <p class="total-price">{{$t(`CURRENCY.${orderObj.currency}`)}} {{orderObj.amount}}</p>
                        </section>
                    </div>

                    <div class="button-box" v-if="config.platform === 'web'">
                        <div class="button-box-inner">
                            <router-link
                            to="/#plans-select"
                            v-if="orderObj.status===paymentStatus.FAILED || orderObj.status===paymentStatus.CANCELLED || orderObj.status===paymentStatus.EXPIRED"
                            class="ui-button primary-button">
                                {{ $t('order_complete.tryAgain') }}
                            </router-link>
                            <router-link to="/user/dashboard/" v-else class="ui-button primary-button">{{$t('nav.dashboard')}}</router-link>
                            <router-link to="/user/cloud-library/" class="ui-button empty-button">{{$t('order_complete.my_library')}}</router-link>
                            <a :href="$t('dashboard.bind_url')" target="_blank" class="ui-link">
                                <span class="text">{{$t('order_complete.upload_video')}}</span>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
            <cart-bottom v-if="config.platform === 'web'"></cart-bottom>
        </div>
        <pop-up
            textAlign='center'
            :title="$t('order_complete.somethingWrong')"
            description=""
            :buttons="buttons"
            @refresh="refresh"
            @comfirm="comfirm"
            v-if="somethingWrong">
        </pop-up>
    </div>
</template>

<script>
import { getOrderDetailById, getPlan } from '@/api/cart';
import { timeResolve } from '@/common/js/date';
import { config } from 'CONFIG';
import cartNav from '@/components/cartNav';
import cartBottom from '@/components/cartBottom';
import { payment as paymentStatus } from '@/config/status';
import { requestToApp, registerHandler } from '@/api/app';
import store from '@/store';
import reolinkGa from '@/common/js/gtagPageview';
import popUp from '@/components/popUp';

export default {

    components: {

        cartNav,
        cartBottom,
        popUp

    },

    data () {

        return {
            
            config,
            orderObj: {},
            orderItems: {},
            timeStr: 0,
            cartIndex: 2,
            paymentStatus,
            howUnit: '',
            howQue: '',
            show: false,
            mode: this.$route.query['r-cloud-mode'],
            prevPlan: this.$route.query['r-cloud-prevPlan'],
            somethingWrong: false,
            buttons: [
                {
                    click: 'comfirm',
                    type: 'primary',
                    text: this.$t( 'order_complete.toMyPlan' )
                },
                {
                    click: 'refresh',
                    type: 'primary',
                    text: this.$t( 'order_complete.refresh' )
                }
            ]

        };

    },

    async created () {

        try {

            if ( config.platform === 'web' ) {
    
                await this.getOrderDetailFun();
    
                // 根据query string里面的prevPlan和订单内的产品信息，更新reolinkGa组件内的数据，
                // 只有在web需要这个操作
                // 在webview时，是直接从cart页面跳转到此页面，reolinkGa内部状态还没有被销毁
                reolinkGa.subscribeMode = this.mode;
                reolinkGa.prevPlan = this.prevPlan;
                reolinkGa.nextPlan = this.orderItems.id;
    
                await this.getProductDetails();
    
            } else if ( store.state.webview.returnToWebviewFirstTime ) {
                
                // 此处处理是为了解决页面跳转顺序问题，在webview页面点击支付之后
                // 会切换到浏览器去paypal的页面支付
                // 此时ios系统的webview页面已经停止运行，此时可能存在两种情形：
                // 1：webview切到后台之后继续跳转至本页面，等到webview切回前台时已到达本页面
                // 2：webview切到后台后已暂停运行，还停留在cart页面，等到webview切回前台才继续跳转到本页面
                //    这种情况无法监听到APP第一次调用的returnedToWebview时间
    
                // 针对情形1
                // 先查询一次状态，再重新注册事件
                // 供app第二次及以后切回前台时调用
                await this.getOrderDetailFun();
                await this.getProductDetails();
                this.registerReturnedToWebview();
                
            } else {
                
                // 针对情形2
                // 注册事件，待app切回来的时候调用
                this.registerReturnedToWebview();
    
            }

        } catch ( err ) {

            console.error( err );

        }
        // 统计订阅事件
        reolinkGa.sendSubscribeMode();

    },

    methods: {
        timeFormat ( time ) {
            
            let {

                year,
                monthLong,
                dateOfMonth

            } = timeResolve( time );

            return [
                `${monthLong} ${dateOfMonth},${year}`,
                `${dateOfMonth} ${monthLong},${year}`
            ];

        },

        async getOrderDetailFun () {

            let orderId = this.$route.query['r-cloud-id'];
            try {

                let res = await getOrderDetailById( orderId );
                this.orderObj = res.data;
                this.orderItems = res.data.items[ 0 ];
                this.timeStr = res.data.createdAt;
                this.show = true;
                if ( config.platform !== 'web' ) {

                    let data = {
    
                        status: res.data.status,
                        paymentId: res.data.id
        
                    };
                    requestToApp( 'updatePaymentStatus', data );

                }

            } catch ( err ) {

                console.error( err );
                console.error( 'get order failed' );
                if ( config.platform !== 'web' ) {

                    this.somethingWrong = true;
                
                }
                throw err;

            }

        },

        getProductDetails () {
            
            getPlan( this.orderItems.id ).then( plan => {

                this.howUnit = plan.cycle.standard.interval.unit;
                this.howQue = plan.cycle.standard.interval.frequency;

            }).catch( err => {

                console.error( 'get plan failed' );
                console.error( err );
                if ( config.platform !== 'web' ) {

                    this.somethingWrong = true;
                
                }
                throw err;
                
            });

        },

        registerReturnedToWebview () {

            registerHandler( 'returnedToWebview', async () => {

                await this.getOrderDetailFun();
                await this.getProductDetails();
    
            });

        },

        comfirm () {

            this.somethingWrong = false;
            requestToApp( 'jumpToMyPlan' );

        },

        refresh () {

            this.somethingWrong = false;
            requestToApp( 'reloadPaymentStatusPage' );

        }

    }

};
</script>

<style scoped lang="less">
.order-contents {
    max-width: 1020px;
    margin: 0 auto;
    padding: 0.6rem 0 1.2rem;
    .order-center {
        margin: 0 auto;
        max-width: 600px;
        padding-bottom: 1.2rem;
        margin-top:0.6rem;
        h1 {
            font-size: 0.26rem;
            font-weight: 500;
            color: #333333;
        }
    }
    .mobile-padding {
        padding: 0 0;
        .send-email {
            font-weight: 400;
            margin-top: 0.25rem;
            color: #666;
            font-size: 0.16rem;
            a {
                color: @theme;
                cursor: pointer;
            }
        }
    }
    .order-info {
        margin-top: 0.3rem;
        border-bottom: solid 0.01rem #dddddd;
        padding-bottom: 0.2rem;
        .fail-reason{
            color:#DD4429;
        }
        li {
            font-weight: 400;
            font-size: 0.16rem;
            color: #666;
            & + li{
                margin-top: 0.1rem;
            }
            .numbers {
                color: #444;
                font-weight: 500;
                font-size: 0.16rem;
                margin-left:0.1rem;
            }
            .numbers.red{
                color:#DD4429;
            }
        }
    }
    .product {
        margin: 0.3rem 0 0.2rem 0;
        h3 {
            font-weight: 500;
            color: #666666;
            margin-bottom: 0.1rem;
            font-size: 0.16rem;
        }
        section {
            display: flex;
            justify-content: space-between;
            padding-right: 0.3rem;
        .reo-time {
            font-weight: 500;
            color: #333;
            font-size: 0.16rem;
            span {
                font-weight: 400;
                font-size: 0.16rem;
                color: #777777;
            }
        }
        }
    }
    .reo-price {
        color: #333333;
        font-weight: 500;
        font-size: 0.16rem;
        padding-bottom: 0.05rem;
    }
    .period {
        border-bottom: solid 0.01rem #dddddd;
        padding: 0 0.3rem 0.3rem 0;
        display: flex;
        justify-content:space-between;
        h3 {
            font-weight: 400;
            color: #666666;
            font-size: 0.16rem;
        }
        section {
            display: flex;
            justify-content: space-between;
        }
    }
    .total {
        padding: 0.3rem 0.3rem 0.6rem 0;
        section {
            display: flex;
            justify-content: space-between;
            h3 {
                font-size: 0.16rem;
                color: #666666;
                font-weight: 400;
            }
            p {
                font-size: 0.26rem;
                color: #333333;
                font-weight: 500;
            }
        }
    }
    .button-box {
        margin-bottom: 1.2rem;
        margin: auto;
        text-align: center;
        .button-box-inner{
            display: inline-block;
            a+a{
                margin-top: 0.2rem;
            }
            &>a{
                display: block;
            }
        }
    }
}
.banner-container {
    .banner{
        display: none;
    }
}
@media @mobile {
     @linear-background: linear-gradient(90deg,@theme-linear-gradient-start,@theme-linear-gradient-end);
    .order-contents{
        padding: 0;
    }
    .banner-box {
        background: @linear-background;
        height: 3.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .banner-container {
        display: block;
        width: 6rem;
        .banner {
            width: 0.8rem;
            height: 0.8rem;
            margin: 0 auto;
            padding-bottom: 0.3rem;
            display: block;
            .have-wrong{
                display: block;
                font-size: 0.8rem;
                color: #fff;
            }
        }
        .banner-text {
            height: 0.85rem;
            text-align: center;
            h1 {
                font-size: 0.36rem;
                font-weight: 500;
                width: 5.5rem;
                color: #fff;
                margin: 0 auto;
            }
        }
    }
    .order-contents .order-center {
        max-width: 100%;
        padding-bottom: 0;
        margin-top: 0;
        .order-info {
            margin-top: 0.4rem;
            border-bottom: solid 0.01rem #dddddd;
            padding-bottom: 0.4rem;
            li {
                font-weight: 400;
                font-size: 0.28rem;
                color: #666;
                & + li{
                    margin-top: 0.15rem;
                }
                .numbers {
                font-size: 0.28rem;
                font-weight: 500;
                color:#444;
                }
            }
        }
    .mobile-padding {
      padding: 0 15px;
    }
    .send-email {
        font-size: 0.28rem;
        margin-top: 0.6rem;
        a {
            color: @theme;
        }
    }
    .product {
        margin: 0.4rem 0;
        h3 {
            margin-bottom: 0.18rem;
            font-size: 0.28rem;
            font-weight: 400;
            color: #666666;
        }
    section {
        display: flex;
        justify-content: space-between;
        padding: 0;
        .reo-time {
          font-weight: 500;
          color: #333;
          font-size: 0.28rem;
          span {
            font-size: 0.26rem;
          }
        }
      }
    }
    .reo-price {
      color: #333;
      font-weight: 400;
      font-size: 0.28rem;
    }
    .period {
        border-bottom: solid 0.01rem #dddddd;
        padding: 0 0 0.4rem 0;
        h3 {
            font-size: 0.28rem;
            font-weight: 400;
        }
        section {
            display: flex;
            justify-content: space-between;
        }
    }
    .total {
        padding: 0.4rem 0 0.8rem 0;
        section {
            display: flex;
            justify-content: space-between;
            h3 {
                font-size: 0.28rem;
                color:#333333;
                font-weight: 400;
            }
            p {
                font-size: 0.35rem;
                color: #333333;
                font-weight: 400;
            }
        }
    }
    .button-box {
        margin-bottom: 1.2rem;
        .button-box-inner{
            display: block;
            a+a{
                margin-top: 0.2rem;
            }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/cart/orderComplete.vue